import React from "react";
import { useState, useEffect } from "react";

function PTLHeader({ showOffer = false, ctaLabel = "Get a Free Quote", hideMiniHeader }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToForm = (e) => {
    e.preventDefault();
    const form =
      document.querySelector('[id$="-hero-form"]') ||
      document.getElementById("leadForm");
    if (form) {
      const offset = form.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: offset, behavior: "smooth" });
      setTimeout(() => {
        const firstInput = form.querySelector("input");
        if (firstInput) firstInput.focus();
      }, 500);
    }
  };

  return (
    <>
      {showOffer && (
        <div style={{
          background: "#0f172a",
          color: "#fff",
          textAlign: "center",
          padding: "10px 16px",
          fontSize: "14px",
          fontWeight: 600,
          fontFamily: "'Poppins', sans-serif",
        }}>
          <span style={{ color: "#facc15" }}>Limited Time Offer:</span>{" "}
          Free Onboarding + Earn Cashback on Your First Recharge
        </div>
      )}

      {/* Top utility bar — matches Header's pz-nav__topbar */}
      {!hideMiniHeader && (
        <div className="pz-nav__topbar">
          <div className="pz-nav__topbar-inner">
            <a href="tel:+919311847248" aria-label="Call Prozo">
              <i className="mdi mdi-phone" /> +91-9311847248
            </a>
            <span className="pz-nav__topbar-sep">|</span>
            <a href="mailto:sales@prozo.com" aria-label="Email Prozo">
              <i className="mdi mdi-email-outline" /> sales@prozo.com
            </a>
          </div>
        </div>
      )}

      <header className={`pz-nav${scrolled ? " pz-nav--scrolled" : ""}`}>
        <div className="pz-nav__inner">
          <div className="pz-nav__logo">
            <img
              src="/media/Prozo-Logo.png"
              height={52}
              alt="Prozo - Supply Chain Operating System"
            />
          </div>

          <a style={{ color: "#fff" }} href="#hero-form" className="pz-nav__cta" onClick={scrollToForm}>
            {ctaLabel} <i className="mdi mdi-arrow-right" />
          </a>
        </div>
      </header>
    </>
  );
}

export default PTLHeader;
